package com.shadowings.gero.data.lessons.chapter13

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.shadowings.gero.data.repository.DatabaseRepositoryImpl
import com.shadowings.gero.data.repository.SentenceOptions
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.Option
import com.shadowings.gero.domain.model.SingleSelectionContent
import com.shadowings.gero.presentation.component.MdCWord
import com.shadowings.gero.presentation.model.Verb
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_preposizione_hr_1
import gero.composeapp.generated.resources.exp_content_preposizione_hr_10
import gero.composeapp.generated.resources.exp_content_preposizione_hr_11
import gero.composeapp.generated.resources.exp_content_preposizione_hr_12
import gero.composeapp.generated.resources.exp_content_preposizione_hr_13
import gero.composeapp.generated.resources.exp_content_preposizione_hr_14
import gero.composeapp.generated.resources.exp_content_preposizione_hr_2
import gero.composeapp.generated.resources.exp_content_preposizione_hr_3
import gero.composeapp.generated.resources.exp_content_preposizione_hr_4
import gero.composeapp.generated.resources.exp_content_preposizione_hr_5
import gero.composeapp.generated.resources.exp_content_preposizione_hr_6
import gero.composeapp.generated.resources.exp_content_preposizione_hr_7
import gero.composeapp.generated.resources.exp_content_preposizione_hr_8
import gero.composeapp.generated.resources.exp_content_preposizione_hr_9
import gero.composeapp.generated.resources.quiz_preposizione_hr_1
import gero.composeapp.generated.resources.quiz_preposizione_hr_1_opt1
import gero.composeapp.generated.resources.quiz_preposizione_hr_1_opt2
import gero.composeapp.generated.resources.quiz_preposizione_hr_1_opt3
import gero.composeapp.generated.resources.quiz_preposizione_hr_1_opt4
import gero.composeapp.generated.resources.quiz_preposizione_hr_2
import gero.composeapp.generated.resources.quiz_preposizione_hr_2_opt1
import gero.composeapp.generated.resources.quiz_preposizione_hr_2_opt2
import gero.composeapp.generated.resources.quiz_preposizione_hr_2_opt3
import gero.composeapp.generated.resources.quiz_preposizione_hr_2_opt4
import gero.composeapp.generated.resources.quiz_preposizione_hr_3
import gero.composeapp.generated.resources.quiz_preposizione_hr_3_opt1
import gero.composeapp.generated.resources.quiz_preposizione_hr_3_opt2
import gero.composeapp.generated.resources.quiz_preposizione_hr_3_opt3
import gero.composeapp.generated.resources.quiz_preposizione_hr_3_opt4
import gero.composeapp.generated.resources.quiz_preposizione_hr_4
import gero.composeapp.generated.resources.quiz_preposizione_hr_4_opt1
import gero.composeapp.generated.resources.quiz_preposizione_hr_4_opt2
import gero.composeapp.generated.resources.quiz_preposizione_hr_4_opt3
import gero.composeapp.generated.resources.quiz_preposizione_hr_4_opt4
import kotlin.random.Random
import gero.composeapp.generated.resources.exp_title_preposizione_hr

fun getPreposizioneHrContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_preposizione_hr,
            content = Res.string.exp_content_preposizione_hr_1,
            face = Faces.Doubt,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_hr,
            content = Res.string.exp_content_preposizione_hr_2,
            face = Faces.Surprised,
            character = Characters.Zeta,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(
                        word = "D2h2:Z1",
                        rtl = false,
                        cart = false,
                        size = 72.dp
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_hr,
            content = Res.string.exp_content_preposizione_hr_3,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_hr,
            content = Res.string.exp_content_preposizione_hr_4,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_hr,
            content = Res.string.exp_content_preposizione_hr_5,
            face = Faces.Serious,
            character = Characters.Alyn,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(
                        word = "D2h2:D21",
                        rtl = false,
                        cart = false,
                        size = 72.dp
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_hr,
            content = Res.string.exp_content_preposizione_hr_6,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_hr,
            content = Res.string.exp_content_preposizione_hr_7,
            face = Faces.Doubt,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_hr,
            content = Res.string.exp_content_preposizione_hr_8,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_hr,
            content = Res.string.exp_content_preposizione_hr_9,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_hr,
            content = Res.string.exp_content_preposizione_hr_10,
            face = Faces.Happy,
            character = Characters.Alyn,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(
                        word = "W19-M17-G43-E13-D2h2:Z1-M17-M40-O34:O1",
                        rtl = false,
                        cart = false,
                        size = 48.dp
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_hr,
            content = Res.string.exp_content_preposizione_hr_11,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_hr,
            content = Res.string.exp_content_preposizione_hr_12,
            face = Faces.Happy,
            character = Characters.Alyn,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(
                        word = "X1:X2-D2h2:Z1-D60-A1",
                        rtl = false,
                        cart = false,
                        size = 56.dp
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_hr,
            content = Res.string.exp_content_preposizione_hr_13,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_hr,
            content = Res.string.exp_content_preposizione_hr_14,
            face = Faces.Happy,
            character = Characters.Zeta,
        ),
    )
}

fun getPreposizioneHrQuizContent(
    verbs: List<Verb>,
    words: List<Word>,
    languageCode: String,
    random: Random = Random,
    verbSentences: List<SentenceOptions> = DatabaseRepositoryImpl.verbSentences
): List<IQuizContent> {
    val specificQuizzes: List<IQuizContent> = listOf(
        SingleSelectionContent(
            text = Res.string.quiz_preposizione_hr_1,
            detail = "",
            options = listOf(
                Option(Res.string.quiz_preposizione_hr_1_opt1, correct = true),
                Option(Res.string.quiz_preposizione_hr_1_opt2, correct = false),
                Option(Res.string.quiz_preposizione_hr_1_opt3, correct = false),
                Option(Res.string.quiz_preposizione_hr_1_opt4, correct = false)
            ).shuffled(random)
        ),
        SingleSelectionContent(
            text = Res.string.quiz_preposizione_hr_2,
            detail = "",
            options = listOf(
                Option(Res.string.quiz_preposizione_hr_2_opt1, correct = true),
                Option(Res.string.quiz_preposizione_hr_2_opt2, correct = false),
                Option(Res.string.quiz_preposizione_hr_2_opt3, correct = false),
                Option(Res.string.quiz_preposizione_hr_2_opt4, correct = false)
            ).shuffled(random)
        ),
        SingleSelectionContent(
            text = Res.string.quiz_preposizione_hr_3,
            detail = "",
            options = listOf(
                Option(Res.string.quiz_preposizione_hr_3_opt1, correct = true),
                Option(Res.string.quiz_preposizione_hr_3_opt2, correct = false),
                Option(Res.string.quiz_preposizione_hr_3_opt3, correct = false),
                Option(Res.string.quiz_preposizione_hr_3_opt4, correct = false)
            ).shuffled(random)
        ),
        SingleSelectionContent(
            text = Res.string.quiz_preposizione_hr_4,
            detail = "",
            options = listOf(
                Option(Res.string.quiz_preposizione_hr_4_opt1, correct = true),
                Option(Res.string.quiz_preposizione_hr_4_opt2, correct = false),
                Option(Res.string.quiz_preposizione_hr_4_opt3, correct = false),
                Option(Res.string.quiz_preposizione_hr_4_opt4, correct = false)
            ).shuffled(random)
        )
    )

    // 3 place-complement + 3 distribution-complement sentences; distribution
    // rows are rare in sentences_verbial.tsv (only OFFRIRE/DARE carry one), so
    // once "seen words" filtering kicks in the pool can run dry early in the
    // chapter - fall back to place-complement sentences instead of leaving
    // the lesson with fewer than 6 sentence quizzes.
    val distributionSentences = if (hasHrComplementCandidate(HrComplementType.DISTRIBUTION, verbs, verbSentences)) {
        buildHrComplementWordSelectionQuizzes(
            type = HrComplementType.DISTRIBUTION,
            count = 3,
            random = random,
            languageCode = languageCode,
            verbSentences = verbSentences,
            words = words,
            verbs = verbs
        )
    } else {
        emptyList()
    }
    val placeCount = 3 + (3 - distributionSentences.size)
    val placeSentences = buildHrComplementWordSelectionQuizzes(
        type = HrComplementType.PLACE,
        count = placeCount,
        random = random,
        languageCode = languageCode,
        verbSentences = verbSentences,
        words = words,
        verbs = verbs
    )

    return specificQuizzes + (placeSentences + distributionSentences).shuffled(random)
}
